const THEME_TETRIS = ["accounting-green-950", "prosperity-stone-200", "accounting-green-950"];
const THEME_TETRIS_TEXT = ["monochrome-white", "accounting-green-950", "monochrome-white"];

export const getItemBackground = (theme: string, index: number) => {
    switch (theme) {

        case "tetris":
            return THEME_TETRIS[index];

        default:
            return THEME_TETRIS[index];
    }
};

export const getItemColor = (theme: string, index: number) => {
    switch (theme) {
        case "tetris":
            return THEME_TETRIS_TEXT[index];

        default:
            return THEME_TETRIS_TEXT[index];
    }
};
